import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@chakra-ui/react';
import { CertifiedBadge } from './CertifiedBadge';
import FileDocumentIcon from './FileDocumentIcon';
function FileCertifiedIcon({ size = 28, ...props }) {
    return (_jsxs(Box, { position: 'relative', children: [_jsx(Box, { position: 'absolute', left: `-${size / 4}px`, top: `-${size / 8}px`, children: _jsx(CertifiedBadge, { size: size, ...props }) }), _jsx(Box, { children: _jsx(FileDocumentIcon, { size: size, ...props }) })] }));
}
export default FileCertifiedIcon;
